<template>
  <Slide ref="slide">
    <Grid slideTag="contact" @animationCallbackReady="(callback) => $emit('animationCallbackReady', callback)">
      <div class="textbox-wrapper">
        <div class="textbox-before slider">
          <h2 class="typ__size_lg typ__style_bold"><span class="line">Let's make</span> <span class="line">something happen.</span></h2>
          <p class="typ__size_md">
            <a class="email" href="mailto:galacemiguel@gmail.com">galacemiguel@gmail.com</a>
          </p>
        </div>
        <div class="textbox-after">
          <h2 class="slider typ__size_lg typ__style_bold">Thank you for your message.</h2>
          <p class="slider typ__size_md">I'll get back to you shortly.</p>
        </div>
      </div>
      <a
        href="mailto:galacemiguel@gmail.com"
        class="send-button send-button--link typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose"
      >Send an email</a>
      <form
        class="contact-form"
        name="contact-form"
        data-netlify="true"
        data-netlify-honeypot="bot-field"
        @submit.prevent="handleSubmit"
      >
        <input
          type="hidden"
          name="bot-field"
        />
        <Grid class="form-grid" slideTag="contact" @animationCallbackReady="(callback) => $emit('animationCallbackReady', callback)">
          <div class="form-col-1 form-col slider" slot="col-1">
            <UnderlineInput
              type="text"
              name="name"
              v-model="form.name"
              label="Name"
              required
            />
          </div>
          <div class="form-col-2 form-col slider" slot="col-2">
            <UnderlineInput
              class="email-input"
              type="email"
              name="email"
              v-model="form.email"
              label="Email"
              required
            />
          </div>
          <div class="form-col-3 form-col slider" slot="col-3">
            <UnderlineInput
              multiline
              class="message-input"
              type="text"
              name="message"
              v-model="form.message"
              label="Message"
            />
            <input class="send-button typ__size_sm typ__style_bold typ__style_uppercase typ__tracking_loose" type="submit" value="Send">
          </div>
        </Grid>
      </form>
    </Grid>
  </Slide>
</template>

<script>
import Slide from '@/components/Slide.vue'
import Grid from '@/components/Grid.vue'
import UnderlineInput from '@/components/UnderlineInput.vue'

export default {
  name: 'ContactSlide',
  components: {
    Slide,
    Grid,
    UnderlineInput
  },
  data: function () {
    return {
      form: {
        name: '',
        email: '',
        message: ''
      }
    }
  },
  methods: {
    encode: function (data) {
      return Object.keys(data).map(key => {
        return `${encodeURIComponent(key)}=${encodeURIComponent(data[key])}`
      }).join('&')
    },
    handleSubmit: function (event) {
      fetch('/', {
        method: 'post',
        headers: {
          'Content-type': 'application/x-www-form-urlencoded'
        },
        body: this.encode({
          'form-name': 'contact-form',
          ...this.form
        })
      }).then((response) => {
        if (response.status === 200) {
          this.$refs.slide.$el.classList.add('slide_animated')
        } else {
          throw new Error(response.status)
        }
      }).catch(() => {

      })
    }
  }
}
</script>

<style scoped lang="scss">
.textbox-wrapper {
  position: relative;
  margin-bottom: 1em;
}

.slider {
  transition: transform $tm__slow-animation $tm__ease-in-out-quint;
  will-change: transform;
}

.textbox-before {
  transition-delay: 450ms;
}

.slide_animated {
  .textbox-before.slider {
    transform: translateY(-100%);
  }
}

.line {
  display: block;
}

.textbox-after {
  position: absolute;
  top: 0;

  .slider {
    transform: translateX(-100%);
  }

  .slider:nth-child(1) {
    transition-delay: 750ms;
  }

  .slider:nth-child(2) {
    transition-delay: 900ms;
  }
}

.slide_animated {
  .textbox-after .slider {
    transform: translateX(0);
  }
}

.send-button--link:hover {
  color: $clr__bg;
}

.form-grid {
  min-height: 80%;
}

.contact-form {
  display: none;
  width: 100%;
  height: 100%;
}

.form-col-1 {
  transition-delay: 300ms;
}

.form-col-2 {
  transition-delay: 150ms;
}

.form-col-3 {
  display: flex;
  flex-direction: column;
}

.slide_animated {
  .form-col.slider {
    transform: translateX(100%);
  }
}

.message-input {
  height: 4em;
  margin-bottom: 1em;
}

.send-button {
  flex-grow: 1;
  height: 2rem;
  background: $clr__body;
  color: $clr__bg;
  cursor: pointer;

  &:hover {
    background: $clr__body-dark;
  }

  &--link {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20em;
    text-decoration: none;
  }
}

@include md-screen {
  .textbox-wrapper {
    margin-bottom: 2em;
  }

  .send-button--link {
    display: none;
  }

  .contact-form {
    display: unset;
  }

  .form-col-3 {
    flex-direction: row;
    align-items: flex-end;
  }

  .message-input {
    width: 75%;
    margin-bottom: 0;
  }
}

@include lg-screen {
  .email-input {
    height: 3em;
  }
}
</style>
